import React from 'react';
import 'index.scss';
import 'components/Footer.scss';

export const Footer = () => {
    return <div id="footer">
        <div id="footer_content">
            Copyright © 2021 MyMove Research Team. All Rights Reserved.
  </div>
    </div>
}